/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */

const updateState = (state: any, what: any) => {
    Object.assign(state, what);
};

const resetState = (state: any, payload: any) => {
    Object.assign(state, payload);
}

interface StateOptions {
    default?: unknown;
    dashboardKeys?: string[];       // Devono essere uguali alle chiavi che si mettono in routes.meta.navbarItems
}

export function State(opts: StateOptions = { default: null }): any {
    return function(target: any, propKey: string, descriptor?: PropertyDescriptor) {
        const val = opts.default || null;

        target._a_state = target._a_state || {};
        target._a_state[propKey] = val;

        target.initialState = target.initialState || {};
        target.initialState[propKey] = val;

        target._a_mutations = target._a_mutations || {};
        target._a_mutations[`set_${propKey}`] = updateState;

        if (!target._a_mutations.reset_state) {
            target._a_mutations["reset_state"] = resetState;
        }
   }
}

export interface FromStoreOptions {
    module?: string;
    prop?: string;
}

export function FromStore(opts?: string | FromStoreOptions): any {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    return function(target: any, propKey: string, descriptor?: PropertyDescriptor) {
        let options: FromStoreOptions;
        if (!opts) {
            options = {};
        } else if (typeof opts === 'string') {
            options = { module: opts };
        } else {
            options = opts;
        }

        const storePropName = options.prop || propKey;
        Object.defineProperty(target, propKey, {
            get: function() {
                let state = this.$store.state;
                if (options.module) {
                    state = state[options.module];
                }
                return state[storePropName];
            },
            set: function(val: unknown) {
                const mutation = options.module ? `${options.module}/set_${storePropName}` : `set_${storePropName}`;
                this.$store.commit(mutation, { [storePropName]: val });
            },
            enumerable: true,
            configurable: false
        });
    }
}
